import { getDb, type ReviewerCandidateRecord } from './db';

/**
 * Upsert candidates while preserving any prior `selectedByEditor` value. This
 * is what makes the reviewer pick state survive an API re-run on existing-skim
 * re-open: the API returns selectedByEditor=false on every record, but the
 * editor's prior selections stick.
 */
export async function bulkInsertCandidates(records: ReviewerCandidateRecord[]): Promise<void> {
  if (records.length === 0) return;
  const db = await getDb();
  const tx = db.transaction('reviewer_candidates', 'readwrite');
  await Promise.all(
    records.map(async (r) => {
      const existing = await tx.store.get(r.id);
      const selectedByEditor = existing?.selectedByEditor ?? r.selectedByEditor;
      await tx.store.put({ ...r, selectedByEditor });
    }),
  );
  await tx.done;
}

export async function candidatesBySkim(skimReportId: string): Promise<ReviewerCandidateRecord[]> {
  const db = await getDb();
  return db.getAllFromIndex('reviewer_candidates', 'by_skim_report', skimReportId);
}

export async function setCandidateSelection(
  id: string,
  selected: boolean,
): Promise<void> {
  const db = await getDb();
  const existing = await db.get('reviewer_candidates', id);
  if (!existing) return;
  await db.put('reviewer_candidates', { ...existing, selectedByEditor: selected });
}

export async function addManualCandidate(record: ReviewerCandidateRecord): Promise<void> {
  const db = await getDb();
  await db.put('reviewer_candidates', record);
}

export async function removeCandidate(id: string): Promise<void> {
  const db = await getDb();
  await db.delete('reviewer_candidates', id);
}
